import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15099624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  class: "row mb-2"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_12 = {
  key: 0,
  value: "",
  disabled: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 2,
  class: "row"
}
const _hoisted_15 = { class: "p-1 form-group d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", {
      class: "has-no-vin mb-2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVinSelect && _ctx.toggleVinSelect(...args)))
    }, "Znam VIN"),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        class: "form-select",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedManufacture) = $event)),
        disabled: !_ctx.getManufacturers.length
      }, [
        _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.getManufacturers.length ? "Wybierz markę..." : "Ładuję marki..."), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getManufacturers, (manufacturer) => {
          return (_openBlock(), _createElementBlock("option", {
            key: manufacturer.id,
            value: manufacturer.id
          }, _toDisplayString(manufacturer.name), 9, _hoisted_4))
        }), 128))
      ], 8, _hoisted_2), [
        [_vModelSelect, _ctx.selectedManufacture]
      ])
    ]),
    (_ctx.selectedManufacture || _ctx.addingNext)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            disabled: !_ctx.selectedManufacture || !_ctx.series.length,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSeries) = $event))
          }, [
            _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.series.length ? "Wybierz model..." : "Ładuję modele..."), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.series, (serie) => {
              return (_openBlock(), _createElementBlock("option", {
                key: serie.rangeId,
                value: serie.rangeId
              }, _toDisplayString(_ctx.serieOptionName(serie)), 9, _hoisted_8))
            }), 128))
          ], 8, _hoisted_6), [
            [_vModelSelect, _ctx.selectedSeries]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedManufacture || _ctx.addingNext)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            disabled: !_ctx.selectedSeries || !_ctx.types.length,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedType) = $event))
          }, [
            _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.types.length || !_ctx.selectedSeries
              ? "Wybierz typ..."
              : "Ładuję typy..."), 1),
            (!_ctx.types.length)
              ? (_openBlock(), _createElementBlock("option", _hoisted_12, "Ładuję..."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type.typeId,
                value: type.typeId
              }, _toDisplayString(_ctx.typeOptionName(type)), 9, _hoisted_13))
            }), 128))
          ], 8, _hoisted_10), [
            [_vModelSelect, _ctx.selectedType]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedManufacture || _ctx.addingNext)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "btn button-gradient btn-width",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectCar && _ctx.selectCar(...args)))
            }, " Wybierz ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}